import { z } from 'zod';

import { defaultPagingSchema } from '../../../helpers/schemas/defaultPagingSchema';

import { applicationsActivationsSortSchema } from './applicationsActivationsSortSchema';
import { getApplicationsActivationsFilterFormSchema } from './components/ActivateApplicationsFilter/helpers/getApplicationsActivationsFilterFormSchema';

const applicationsActivationsFilterFormSchema =
	getApplicationsActivationsFilterFormSchema();

export const applicationsActivationsValidateSearchSchema =
	defaultPagingSchema.extend({
		openedActivation: z.string().optional().catch(undefined),
		filter: applicationsActivationsFilterFormSchema.optional().catch(undefined),
		sort: applicationsActivationsSortSchema,
	});
